import styled from "styled-components";

export const ChatbotInitialSelector = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  .file-selection {
    flex: 1;
    display: flex;
    flex-direction: column;
    background-color: #f0f0ff;
    padding: 15px 20px;
    border-radius: 20px;
    margin: 20px;
    overflow: auto;
    &__empty {
      margin: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #2a28d6;
      &-icon {
        font-size: 100px;
      }
      &-text {
        font-size: 17px;
        margin-top: 20px;
        font-family: "Nunito Sans";
      }
    }
  }
  .footer-selection {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    &__patient {
      display: flex;
      flex-direction: column;
      color: #3e3e5b;
      font-size: 14px;
      .label {
        font-family: "Nunito Sans Bold";
      }
    }
  }

  .file-selected {
    display: flex;
    flex-direction: column;
    height: 100%;
    &__top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0px 20px 20px;
      &-button {
        width: 100px;
      }
      &-patient {
        display: flex;
        flex-direction: column;
        color: #3e3e5b;
        font-size: 14px;
        .label {
          font-family: "Nunito Sans Bold";
        }
      }
    }
  }
  .alert-message {
    padding: 0px 20px 10px;
    font-size: 13px;
    color: #707582;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .chatbot-container {
    padding: 0px 14px 0px 29px;
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow-y: scroll;
    &__empty {
      margin: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    &__empty-container {
      width: 180px;
      position: relative;
      display: flex;
      justify-content: center;
      &__shadow {
        z-index: 1;
        display: flex;
        /* width: 10px; */
        /* height: 10px; */
        position: absolute;
        align-self: center;
        box-shadow: 0px 3.03px 121.47px 60px #3e76fa66;
      }
    }
    &__empty-image {
      width: 180px;
      height: 100%;
      z-index: 2;
    }
    &__empty-msg {
      margin-top: 20px;
      font-size: 17px;
      color: #707582;
    }
  }

  .file-selected {
    background-color: #f0f0ff;
    justify-content: center;
    justify-items: center;
    .header {
      display: flex;
      justify-content: space-between;
      padding: 20px;
      width: 100%;
      box-sizing: border-box;
      &__close {
        background-color: #3e3da3;
        width: 40px;
        height: 40px;
        border-radius: 27.5px;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        font-size: 14px;
      }
      &__info {
        display: flex;
      }
      &__img {
        margin-right: 10px;
      }
      &__text {
        color: #68688d;
        align-items: center;
      }
    }
    &__bottom {
      justify-content: center;
      .label {
        margin-top: 15px;
        text-align: center;
        color: #1f1f52;
        font-size: 15px;
        font-family: "Nunito Sans";
        margin-bottom: 10px;
      }
    }
  }
  .files {
    overflow: auto;
    place-items: center;
    height: 100%;
  }
  .file {
    height: 250px;
    width: 300px;
    border-radius: 14px;
    overflow: hidden;
    margin-bottom: 10px;
    position: relative;
    .file__preview {
      width: 100%;
      height: 100%;
      background-color: #fff;
      color: #707582;
      display: flex;
    }
    .file__icon {
      margin: auto;
      font-size: 172px;
    }
    .file__img {
      width: 100%;
      height: 100%;
      border: 2px solid #ffffff7d;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .file__title {
      width: 100%;
      padding: 16px 10px;
      color: #1f1f52;
      font-size: 12px;
      background-color: #f2f2f794;
      position: absolute;
      bottom: 0;
    }
  }
`;
